import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BetriebskontaktCardComponent } from './betriebskontakt-card.component';

@NgModule({
    declarations: [BetriebskontaktCardComponent],
    imports: [CommonModule, MatCardModule, MatButtonModule, MatIconModule, MatMenuModule, MatProgressSpinnerModule],
    exports: [BetriebskontaktCardComponent],
})
export class BetriebskontaktCardModule {}
